"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduceArrayFromArray = void 0;
var reduceArrayFromArray = function (array, arrayToReduce) {
    return array.filter(function (item) { return !arrayToReduce.includes(item); });
};
exports.reduceArrayFromArray = reduceArrayFromArray;
//# sourceMappingURL=array.utils.js.map